<div class="chat-item"
  [class.active]="isActive"
  [class.chat-item--editing]="isEditing()"
  (click)="onItemClick()"
  data-testid="chat-history-item">
  @if (isEditing()) {
    <input
      class="chat-title-input"
      type="text"
      [value]="editingTitle()"
      (input)="onTitleInput($event)"
      (keydown)="onEditKeydown($event)"
      (click)="$event.stopPropagation()"
      data-testid="chat-title-input"
      autofocus
    />
    <button class="edit-action-btn confirm-btn" (click)="confirmEdit($event)" [matTooltip]="'Save'" data-testid="chat-title-confirm-btn">
      <img [src]="'/svg/confirm-edit.svg' | assetVersion" width="16" height="16" alt="Save" />
    </button>
    @if (editingError()) {
      <div class="chat-title-error" data-testid="chat-title-error">{{ editingError() }}</div>
    }
  } @else {
    <div class="chat-title">{{ chat.title }}</div>
    @if (!isLegacyFlow()) {
      <button class="edit-action-btn edit-title-btn" (click)="startEditing($event)" [matTooltip]="'Edit title'" data-testid="chat-title-edit-btn">
        <img [src]="'/svg/note-pencil.svg' | assetVersion" width="16" height="16" alt="Edit title" />
      </button>
    }
  }
</div>